import state from './client.state'
import mutations from './client.mutations'
import actions from './client.actions'
import getters from './client.getters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}


//////////////////
// WEBPACK FOOTER
// ./state/client/client.module.js
// module id = null
// module chunks = 